import { PLAN_TOOLS } from '../../utils';

export const reportsRoutes = (prefix = '') => [
  {
    path: 'reports',
    name: `${prefix}/app/reports`,
    component: () => import('@/portals/Application/Reports'),
    redirect: `${prefix}/reports/sales/products`,
    children: [
      {
        path: 'sales',
        component: () => import('@/portals/Application/Reports/Sales/index'),
        children: [
          {
            path: ':reportType(stores)',
            component: () => import('@/portals/Application/Reports/Sales/Stores/index')
          },
          {
            path: ':reportType(category)',
            component: () => import('@/portals/Application/Reports/Sales/Category/index')
          },
          {
            path: ':reportType(facets)',
            component: () => import('@/portals/Application/Reports/Sales/Facets/index')
          },
          {
            path: ':reportType(suppliers)',
            component: () => import('@/portals/Application/Reports/Sales/Suppliers/index')
          },
          {
            path: ':reportType(orders)',
            meta: { requiredTools: PLAN_TOOLS.REPORTING[0].value },
            component: () => import('@/portals/Application/Reports/Sales/Orders/index')
          },
          {
            path: ':reportType(products)',
            meta: { requiredTools: PLAN_TOOLS.REPORTING[0].value },
            component: () => import('@/portals/Application/Reports/Sales/Products/index')
          },
          {
            path: ':reportType(users)',
            component: () => import('@/portals/Application/Reports/Sales/Users/index')
          },
          {
            path: ':reportType(company)',
            component: () => import('@/portals/Application/Reports/Sales/Company/index')
          },
          {
            path: ':reportType(additional-charges)',
            component: () => import('@/portals/Application/Reports/Sales/Charges/index')
          }
        ]
      },
      // ---------- Customers ------------
      {
        path: 'customer',
        component: () => import('@/portals/Application/Reports/Customers/index'),
        children: [
          {
            path: ':reportType(sales)',
            component: () => import('@/portals/Application/Reports/Customers/Sales/index')
          },
          {
            path: ':reportType(values)',
            component: () => import('@/portals/Application/Reports/Customers/CustomerValues/index')
          },
          {
            path: ':reportType(all)',
            component: () => import('@/portals/Application/Reports/Customers/AdminAll/index')
          },
          {
            path: ':reportType(referrer)',
            component: () => import('@/portals/Application/Reports/Customers/Referrers/index')
          },
          {
            path: ':reportType(source)',
            component: () => import('@/portals/Application/Reports/Customers/Source/index')
          },
          {
            path: ':reportType(acquisition)',
            component: () => import('@/portals/Application/Reports/Customers/Acquisition/index')
          }
        ]
      },

      // ---------- Finance ------------
      {
        path: 'finance',
        component: () => import('@/portals/Application/Reports/Finance/index'),
        children: [
          {
            path: ':reportType(commissions)',
            component: () => import('@/portals/Application/Reports/Finance/Commissions')
          },
          {
            path: ':reportType(payments)',
            component: () => import('@/portals/Application/Reports/Finance/Payments')
          },
          {
            path: ':reportType(orders-aging)',
            component: () => import('@/portals/Application/Reports/Finance/OrdersAging')
          },
          {
            path: ':reportType(fundraising)',
            component: () => import('@/portals/Application/Reports/Finance/Fundraising')
          },
          {
            path: ':reportType(fundraising-details)',
            component: () => import('@/portals/Application/Reports/Finance/FundraisingDetails')
          }
        ]
      },
      // ---------- Managment ------------
      {
        path: 'management',
        component: () => import('@/portals/Application/Reports/Management/index'),
        children: [
          {
            path: ':reportType(emails-activity)/:storeId',
            component: () => import('@/portals/Application/Reports/Management/EmailsActivity')
          },
          {
            path: ':reportType(emails-activity)',
            component: () => import('@/portals/Application/Reports/Management/EmailsActivity')
          },
          {
            path: ':reportType(order-distributions)',
            component: () => import('@/portals/Application/Reports/Management/LeadDistributions')
          },
          {
            path: ':reportType(follow-ups)',
            component: () => import('@/portals/Application/Reports/Management/FollowUps/index')
          },
          {
            path: ':reportType(batch-email)',
            component: () => import('@/portals/Application/Reports/Management/BatchEmailActivity')
          },
          {
            path: ':reportType(order-activity)',
            component: () => import('@/portals/Application/Reports/Management/OrderActivity')
          },
          {
            path: ':reportType(order-details)',
            component: () => import('@/portals/Application/Reports/Management/OrderDetails')
          },
          {
            path: ':reportType(user-customers)',
            component: () => import('@/portals/Application/Reports/Management/UserCustomers')
          },
          {
            path: ':reportType(close-ratio)',
            component: () => import('@/portals/Application/Reports/Management/OrderCloseRatio')
          },
          {
            path: ':reportType(store-traffic)',
            component: () => import('@/portals/Application/Reports/Management/StoreTraffic/index')
          }
        ]
      },
      // ---------- Orders ------------
      {
        path: 'orders',
        component: () => import('@/portals/Application/Reports/Customers/index'),
        children: [
          {
            path: ':reportType(acquisition)',
            component: () => import('@/portals/Application/Reports/Orders/Acquisition/index')
          }
        ]
      }
    ]
  },
  {
    path: 'logs',
    name: `${prefix}/app/logs`,
    component: () => import('@/portals/Application/Reports'),
    redirect: `${prefix}/reports/sales/products`,
    children: [
      {
        path: 'customer-distribution-log',
        component: () => import('@/portals/Administration/Orders/OrderSalesAdminLogs')
      }
    ]
  }
];
